import { render, staticRenderFns } from "./database3.vue?vue&type=template&id=a08b77d0&scoped=true&"
import script from "./database3.vue?vue&type=script&lang=js&"
export * from "./database3.vue?vue&type=script&lang=js&"
import style0 from "./database3.vue?vue&type=style&index=0&id=a08b77d0&prod&lang=css&"
import style1 from "./database3.vue?vue&type=style&index=1&id=a08b77d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08b77d0",
  null
  
)

export default component.exports